import { FunctionComponent, useContext } from 'react'
import contextBlickTV from '@contexts/blickTV'
import * as BlickTVStoryComponents from '@components/Video/BlickTVStory'
import BlickTVTeaserComponents from '@components/BlickTVTeaser'
import { BlickTVTeaserProps } from './types'
import BlickTVStoryProvider from '@widgets/Video/story/BlickTVStoryProvider'
import BlickTVStory from '@widgets/Video/story/BlickTVStory'
import BlickTVViewport from './BlickTVViewport'

const { Wrapper } = BlickTVTeaserComponents

const { BlickTVContext } = contextBlickTV

const { WidgetWrapper, StoryWrapper, VideoWrapper } = BlickTVStoryComponents

export type { BlickTVTeaserProps }

const BlickTVTeaser: FunctionComponent<BlickTVTeaserProps> = (props) => {
  // TODO: add isE2ETest when it is ready
  const isE2ETest = false

  const {
    title,

    video: {
      isBlickTV,
      teaserAutoplay: autoplay,
      allowFloating,
      isAdDisabled,
      position,
      syndication,
      allowVideoCropping,
      duration,
      videoId,
      daiAssetKeyBrightcove,
    },
  } = props

  const { popIn, popOut } = useContext(BlickTVContext)

  const darkCoveElement = {
    ...{
      isBlickTV,
      allowFloating,
      isAdDisabled,
      position,
      syndication,
      allowVideoCropping,
      duration,
      videoId,
      title,
      daiAssetKeyBrightcove,
    },
    autoplay,
    ...(isE2ETest ? { isAdDisabled: true } : {}),
    isInVideoOnlyArticle: false,
  }

  return (
    <WidgetWrapper>
      <BlickTVStoryProvider>
        <VideoWrapper>
          <Wrapper>
            <BlickTVViewport
              popIn={popIn}
              popOut={popOut}
              {...darkCoveElement}
            />
          </Wrapper>
        </VideoWrapper>
        <StoryWrapper>{<BlickTVStory {...props} />}</StoryWrapper>
      </BlickTVStoryProvider>
    </WidgetWrapper>
  )
}

export default BlickTVTeaser
